import { NegotiationType } from '../lib'

export const parseToNegotiationType = (value: string): NegotiationType | undefined => {
  const numericValue = parseInt(value, 10)

  if (numericValue in NegotiationType) {
    return numericValue as NegotiationType
  }

  return undefined
}

export const parseNumber = (numberToCast: number | string) => {
  if (!numberToCast) return '0.00'

  const partsOfNumber = String(numberToCast).split('.')
  partsOfNumber[0] = String(Number(partsOfNumber[0])).replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  return partsOfNumber.join('.')
}
